import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import type { ReactNode } from 'react';

const RECAPTCHA_SITE_KEY =
  (import.meta.env['VITE_RECAPTCHA_SITE_KEY'] as string) || '';

interface RecaptchaProviderProps {
  children: ReactNode;
}

/**
 * Wrapper component for Google reCAPTCHA v3 Provider
 * Only wrap pages that need reCAPTCHA with this provider
 */
export function RecaptchaProvider({ children }: RecaptchaProviderProps) {
  if (!RECAPTCHA_SITE_KEY) {
    console.warn('VITE_RECAPTCHA_SITE_KEY is not configured');
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
